import wixWindowFrontend from "wix-window-frontend";
import { getJSON } from 'wix-fetch'

const GET_COUNTRY_ENDPOINT = "https://www.wix.com/wix-platform/new-pp/_functions/country"

export const getCountryCode = () => {
    if (wixWindowFrontend.rendering.env === 'browser') {
        return getJSON(GET_COUNTRY_ENDPOINT).then(({ countryCode }) => countryCode)
    }
}